module.exports = "/images/wrongTrade.svg";